/**
 * Fetch Course Library API
 * GET /api/courses/library
 * Fetches available courses for adding to learning paths with search and filters
 */

import axiosInstance from "../axiosInstance";
import type {
  FetchCourseLibraryParams,
  FetchCourseLibraryResponse,
} from "@/modules/learningCenter/features/LearningPaths/apiTypes";

/**
 * Fetches course library with optional filters
 * @param params - Search and filter parameters
 * @returns Paginated list of courses
 */
export const fetchCourseLibrary = async (
  params?: FetchCourseLibraryParams
): Promise<FetchCourseLibraryResponse> => {
  const response = await axiosInstance.get<FetchCourseLibraryResponse>(
    '/api/courses/library',
    { params }
  );
  return response.data;
};
